module.exports = __webpack_public_path__ + "img/sad-color-outlined-icon.svg";